import * as React from 'react';

import PropTypes from 'prop-types';

// @ts-ignore
import PromptActions from 'actions/PromptActions';
import { PromptNames } from 'constants/PromptConstants';
import JoinGroupModal from 'groups/components/JoinGroupModal';
// @ts-ignore
import PromptStore from 'stores/PromptStore';

class SetupSubscription extends React.Component<{}> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  };

  componentDidMount() {
    if (!PromptStore.hasDismissed(PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION)) {
      PromptActions.recordDismissal(PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION);
    }
  }

  onJoinGroup = () => {
    this.context.router.push(this.context.location?.state?.location ?? '/');
  };

  render() {
    return (
      <JoinGroupModal
        modal={false}
        onRequestHide={this.onJoinGroup}
        onJoin={this.onJoinGroup}
        isInSetupFlow
      />
    );
  }
}

export default SetupSubscription;
